import { RootNavigator, routeConfigs } from "../navigators/RootNavigator";
import { NavigationActions } from "react-navigation";


export function getActionForPathAndParams(path, params) {
  let action = RootNavigator.router.getActionForPathAndParams(path, params);
  if (action) {
    return action;
  }
  const routeName = Object.keys(routeConfigs).find(tabId => {
    const pathToTest = routeConfigs[tabId].path;
    if (!pathToTest) {
      return false;
    }
    const [...paramNames] = pathToTest.match(/:([^/]+)/g) || [];
    const re = new RegExp('^' + pathToTest.replace(/:([^/]+)/g, '([^/]+)') + '$');
    const [isMatch, ...paramValues] = path.match(re) || [false];
    if (isMatch && paramNames.length === paramValues.length) {
      params = {
        ...paramNames.reduce((prev, name, i) => {
          prev[name.substr(1)] = paramValues[i];
          return prev
        }, {}), ...params
      };
      path = pathToTest;
      return true;
    }
    return false;
  });
  if (routeName) {
    return NavigationActions.navigate({ routeName, params });
  }
  return null;
}

export function resolvePathAndParamsToUri(path, params) {
  const parts = path.split('/');
  const resolvedParts = parts.map(part => {
    if (part.substr(0, 1) !== ':') {
      return part;
    }
    const paramName = part.substr(1);
    if (params && params[paramName]) {
      return params[paramName];
    } else {
      console.warn(`Missing param ${paramName} for route ${path}`);
      return part;
    }
  });
  return `/${resolvedParts.join('/')}`;
}

export function getURIForAction(action, navigation) {
  const state = RootNavigator.router.getStateForAction(action, navigation);
  const { path, params } = RootNavigator.router.getPathAndParamsForState(state);
  return resolvePathAndParamsToUri(path, params);
}

export default (state, action) => {
  if (!state) {
    const path = window.location.pathname.substr(1),
      params = window.location.search.substr(1);
    state = RootNavigator.router.getStateForAction(
      getActionForPathAndParams(path, params) ||
      NavigationActions.navigate({ params: { path, params }, routeName: 'NotFound' })
    );

  }

  const nextState = RootNavigator.router.getStateForAction(action, state);

  // Simply return the original `state` if `nextState` is null or undefined.
  return nextState || state;
};



// WEBPACK FOOTER //
// ./src/modules/navigation.js